module.exports = __webpack_public_path__ + "img/honorguard_cruiser.776dc54c.jpg";